import { render } from "./MarketingMember.vue?vue&type=template&id=95faaa14&scoped=true"
import script from "./MarketingMember.vue?vue&type=script&lang=js"
export * from "./MarketingMember.vue?vue&type=script&lang=js"

import "./MarketingMember.vue?vue&type=style&index=0&id=95faaa14&scoped=true&lang=css"

import exportComponent from "F:\\omar pos 2\\pos_administration_platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95faaa14"]])

export default __exports__